import React, { useEffect, useMemo, useState } from "react";
import { useForm, usePopover } from "hooks";
import {
  Page,
  withModelResolve,
  FormGroup,
  PendingButton,
  SubmitButton,
  InputGroup,
} from "components/common";
import { Card, Table, Button, CardDeck, Row, Col, Badge } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import { track, Fieldset, Control, actions } from "react-redux-form";
import { groupBy, reduce, sumBy, mapValues, isString, valuesIn } from "lodash";
import { isCurrency, formatCurrency } from "services/util";
import shortid from "shortid";
import SummaryCard from "./SummaryCard";
import { NotificationManager } from "react-notifications";
import numeral from "numeral";
import BackButton from "components/refactoring/BackButton";
import { BillPayment } from "../Loans/Payment";

const TypeLine = withModelResolve(
  ({ modelValue, model, dispatch, fieldValue, onRemove, readOnly }) => {
    const { subtype, type } = modelValue;

    const isOvertime = subtype === "Overtime";
    const isCashedHoliday = subtype === "Cashed holiday";
    const isEndOfService = subtype === "End of service";
    const isPolicyDeduction = subtype === "Policy deduction";
    const isAllowanceRule = fieldValue.initialValue.is_allowance_rule;
    const isTax = type === "TAX";

    return (
      <Fieldset model={model} component="tr">
        <td className="p-0">
          <FormGroup model=".description" className="mb-0">
            {isOvertime ? (
              <Row noGutters>
                <Col>
                  <FormGroup model=".description" className="mb-0 mr-1">
                    <Control.text
                      className="form-control-sm"
                      model=".description"
                      validators={(v) => v}
                      updateOn="blur"
                      readOnly={readOnly}
                    />
                  </FormGroup>
                </Col>
                {/* <Col> */}
                {/* <FormGroup model=".hours" className="mb-0 mr-1">
                    <InputGroup suffixText="hours" size="sm">
                      <Control.text
                        className="form-control-sm text-end"
                        model=".hours"
                        updateOn="blur"
                        validators={(v) => isCurrency(v)}
                        onBlur={(e) => {
                          const { value } = e.target;
                          if (isCurrency(value)) {
                            const v = numeral(value)
                              .multiply(modelValue.rate)
                              .format("0.00");
                            dispatch(actions.change(`${model}.amount`, v));
                            dispatch(actions.validate(`${model}.amount`));
                          }
                        }}
                        readOnly={readOnly}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col className="mr-1">
                  <FormGroup model=".rate" className="mb-0">
                    <InputGroup suffixText="rate" size="sm">
                      <Control.text
                        className="form-control-sm text-end"
                        model=".rate"
                        updateOn="blur"
                        validators={(v) =>
                          isCurrency(v, { decimal_digits: "0,4" })
                        }
                        readOnly
                      />
                    </InputGroup>
                  </FormGroup>
                </Col> */}
              </Row>
            ) : isCashedHoliday || isEndOfService ? (
              <Row noGutters>
                <Col>
                  <FormGroup model=".description" className="mb-0 mr-1">
                    <Control.text
                      className="form-control-sm"
                      model=".description"
                      validators={(v) => v}
                      updateOn="blur"
                      readOnly={readOnly || isTax || isEndOfService}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup model=".days" className="mb-0 mr-1">
                    <InputGroup suffixText="days" size="sm">
                      <Control.text
                        className="form-control-sm text-end"
                        model=".days"
                        updateOn="blur"
                        validators={(v) => isCurrency(v)}
                        onBlur={(e) => {
                          const { value } = e.target;
                          if (isCurrency(value)) {
                            const v = numeral(value)
                              .multiply(modelValue.rate)
                              .format("0.00");
                            dispatch(actions.change(`${model}.amount`, v));
                            dispatch(actions.validate(`${model}.amount`));
                          }
                        }}
                        readOnly={readOnly || isTax || isEndOfService}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col className="mr-1">
                  <FormGroup model=".rate" className="mb-0">
                    <InputGroup suffixText="daily rate" size="sm">
                      <Control.text
                        className="form-control-sm text-end"
                        model=".rate"
                        updateOn="blur"
                        validators={(v) =>
                          isCurrency(v, { decimal_digits: "0,4" })
                        }
                        readOnly
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
            ) : (
              <FormGroup model=".description" className="mb-0">
                <Control.text
                  className="form-control-sm"
                  model=".description"
                  validators={(v) => v}
                  updateOn="blur"
                  readOnly={readOnly || isTax || isPolicyDeduction || isAllowanceRule}
                />
              </FormGroup>
            )}
          </FormGroup>
        </td>
        <td className="py-0">
          <FormGroup model=".amount" className="mb-0">
            <Control.text
              type="number"
              // min="0"
              className="form-control-sm text-end"
              model=".amount"
              updateOn="blur"
              validators={(v) => isCurrency(v)}
              readOnly={readOnly || isTax || isPolicyDeduction || isAllowanceRule}
            />
          </FormGroup>
        </td>
        <td className="py-0">
          {!isTax &&<div className="">
            <FormGroup model=".is_taxable" className="mb-0 py-0 position-relative" >
              <Control.checkbox
                className="form-control-sm my-0 position-relative"
                model=".is_taxable"
                disabled={readOnly || isTax || isPolicyDeduction || isAllowanceRule}
              />
            </FormGroup>
          </div>}
        </td>
        <td className="py-0">
          {!readOnly && (
            <Button
              color="link"
              size="sm"
              onClick={onRemove}
              className="text-danger"
            >
              <span className="fa fa-trash fa-lg" />
            </Button>
          )}
        </td>
      </Fieldset>
    );
  }
);

const TypeLines = withModelResolve(
  ({
    type,
    title,
    lines,
    dispatch,
    model,
    readOnly,
    employeeOvertimePerHour,
  }) => {
    const total = formatCurrency(sumBy(lines, (i) => parseFloat(i.amount)));

    return (
      <Fieldset model={model}>
        <Card body className="mb-2">
          <h3><Trans>{title}</Trans></h3>
          {lines.length > 0 ? (
            <Table size="sm" borderless>
              <thead>
                <tr>
                  <th>
                    <Trans>Description</Trans>
                  </th>
                  <th>
                    <Trans>Amount</Trans>
                  </th>
                  <th><Trans>Taxable</Trans></th>
                  <th><Trans>Actions</Trans></th>
                </tr>
              </thead>
              <tbody>
                {lines.map((i) => (
                  <TypeLine
                    readOnly={readOnly}
                    onRemove={() => {
                      dispatch(actions.filter(model, (j) => j.id !== i.id));
                    }}
                    key={i.id}
                    model={track(model, { id: i.id })}
                  />
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td />
                  <td className="text-end pr-2">
                    <span className="font-weight-bold mr-2">
                      <Trans>Total {title}</Trans>:
                    </span>
                    {title === 'Deductions' ? `(${total})` : total}
                  </td>
                </tr>
              </tfoot>
            </Table>
          ) :
            <p className="text-center"><Trans>No Data</Trans></p>}
          {!readOnly && (
            <div className="d-flex justify-content-end">
              {employeeOvertimePerHour ? (
                <PendingButton
                  color="success"
                  size="sm"
                  className="mr-1"
                  icon="fa fa-plus mr-1"
                  onClick={() => {
                    dispatch(
                      actions.push(model, {
                        id: shortid(),
                        type,
                        subtype: "Overtime",
                        description: "Overtime Hours",
                        rate: employeeOvertimePerHour,
                        amount: "",
                      })
                    );
                  }}
                >
                  Add Overtime Hours
                </PendingButton>
              ) : null}
              <PendingButton
                color="success"
                size="sm"
                icon="fa fa-plus mr-1"
                onClick={() => {
                  dispatch(
                    actions.push(model, {
                      id: shortid(),
                      type,
                      description: "",
                      amount: "",
                    })
                  );
                }}
              >
                {lines.length > 0 ? "Add Another" : "Add New"}
              </PendingButton>
            </div>
          )}
        </Card>
      </Fieldset>
    );
  }
);

const EmployeeForm = withModelResolve(({ model, readOnly, modelValue, t }) => {
  const groupedLines = useMemo(
    () => groupBy(modelValue.lines, "type"),
    [modelValue.lines]
  );
  const totals = useMemo(() => {
    const result = reduce(
      groupedLines,
      (acc, i, type) => {
        const sum = sumBy(i, (j) => parseFloat(j.amount));
        acc[type] += sum;
        if (
          type === "EARNING" ||
          type === "REIMBURSEMENT" ||
          type === "ALLOWANCE"
        ) {
          acc["NET"] += sum;
        } else if (type === "TAX" || type === "DEDUCTION") {
          acc["NET"] -= sum;
        }
        return acc;
      },
      {
        EARNING: 0,
        REIMBURSEMENT: 0,
        ALLOWANCE: 0,
        TAX: 0,
        NET: 0,
        DEDUCTION: 0,
        // OVERTIME: 0,
        // LATETIME: 0,
      }
    );
    return mapValues(result, (v) => formatCurrency(v));
  }, [groupedLines]);

  return (
    <Fieldset model={model}>
      <CardDeck className="mb-3 px-2">
        <SummaryCard title="Earnings" value={totals["EARNING"] || "0.00"} />
        <SummaryCard
          title="Reimbursements"
          value={totals["REIMBURSEMENT"] || "0.00"}
        />
        <SummaryCard title="Allowances" value={totals["ALLOWANCE"] || "0.00"} />
        {/* <SummaryCard title="Overtime" value={totals["OVERTME"] || "0.00"} /> */}
        <SummaryCard title="Deductions" value={totals["DEDUCTION"] || "0.00"} />
        {/* <SummaryCard title="Latetime" value={totals["LATETIME"] || "0.00"} /> */}
        <SummaryCard title="Tax" value={totals["TAX"] || "0.00"} />
        <SummaryCard title="Net" value={totals["NET"] || "0.00"} />
        <SummaryCard title="Paid" value={modelValue.total_paid || "0.00"} />
      </CardDeck>
      <TypeLines
        model=".lines"
        type="EARNING"
        title="Earnings"
        readOnly={readOnly}
        employeeOvertimePerHour={modelValue.employee__overtime_per_hour}
        lines={groupedLines["EARNING"] || []}
      />
      <TypeLines
        model=".lines"
        type="REIMBURSEMENT"
        title="Reimbursements"
        readOnly={readOnly}
        lines={groupedLines["REIMBURSEMENT"] || []}
      />
      <TypeLines
        model=".lines"
        type="ALLOWANCE"
        title="Allowances"
        readOnly={readOnly}
        lines={groupedLines["ALLOWANCE"] || []}
      />
      <TypeLines
        model=".lines"
        type="DEDUCTION"
        title="Deductions"
        readOnly={readOnly}
        lines={groupedLines["DEDUCTION"] || []}
      />
      <TypeLines
        model=".lines"
        type="TAX"
        title="Tax"
        readOnly={readOnly}
        lines={groupedLines["TAX"] || []}
      />
    </Fieldset>
  );
});

const CashHoliday = ({ client, url, onSubmit: onSubmitProp }) => {
  const { Popover, isOpen, setIsOpen, target, PopoverBody } = usePopover();
  const [data, setData] = useState();
  const { setValue, Form, dispatch } = useForm();
  const { t } = useTranslation();

  useEffect(
    () =>
      void (async () => {
        const data = await client.get(url).get("data");
        setValue({
          num_days: "",
        });
        setData(data);
      })(),
    []
  );

  async function onSubmit({ num_days }) {
    try {
      await onSubmitProp({
        num_days,
        rate: data.employee__daily_rate,
      });
      setIsOpen(false);
    } finally {
      dispatch(actions.setPending("local", false));
    }
  }

  if (!data) return null;

  return (
    <>
      <PendingButton id={target} onClick={() => setIsOpen(true)}>
        Cash Holiday
      </PendingButton>
      {isOpen && (
        <Popover>
          <PopoverBody>
            <p>
              <Trans>
                Employee has{" "}
                {{
                  num_days: data.remaining_holidays,
                }}{" "}
                accrued holidays available.
              </Trans>
            </p>
            <Form onSubmit={onSubmit} component="div">
              <FormGroup
                label={t("Number of accrued days to cash")}
                model=".num_days"
              >
                <Control.text model=".num_days" validators={isCurrency} />
              </FormGroup>
              <SubmitButton onClick={() => dispatch(actions.submit("local"))}>
                Confirm
              </SubmitButton>
            </Form>
          </PopoverBody>
        </Popover>
      )}
    </>
  );
};

export const PaySlip = ({ payroll, match, t, history }) => {
  const { id, pay_slip_id } = match.params;
  const url = `pay_runs/${id}/pay_slips`;
  const [reload, setReload] = useState(false);
  const { loaded, load, setValue, Form, save, value, dispatch } = useForm({
    enableStoreLogging: true,
  });

  useEffect(() => {
    (async () => {
      const value = await load(payroll, url, pay_slip_id);
      setValue(value);
    })();
  }, [reload]);

  async function onSubmit({ lines, ...x }) {
    dispatch(actions.setPending("local", true));
    try {
      await save(payroll, url, {
        ...x,
        lines: lines.map((i) => ({
          ...i,
          id: isString(i.id) ? undefined : i.id,
        })),
      });
      // history.replaceUp({
      //   pathname: "../..",
      // });
      NotificationManager.success(t("Pay slip successfully saved"));
    } finally {
      dispatch(actions.setPending("local", false));
    }
  }

  function onCashHolidaySubmit({ num_days, rate }) {
    const amount = numeral(num_days).multiply(rate).format("0.00");

    dispatch(
      actions.push("local.lines", {
        id: shortid(),
        type: "EARNING",
        subtype: "Cashed holiday",
        description: "Cashed holiday",
        rate: rate,
        days: num_days,
        amount,
      })
    );
  }

  if (!loaded) return null;

  const readOnly = value.pay_run__status !== "Draft";

  return (
    <Page title={t("Payslip")}>
      <BackButton />
      <div className="border profile p-2 my-3">
        <div className="row">
          <div className="col-auto">
            <p className="display-3 mt-2 mb-0 ml-2"><i className="fa fa-user-circle text-muted" aria-hidden="true"></i></p>
          </div>
          <div className="col text-left">
            <h5 className="my-2 text-success">{value.employee__full_name}</h5>
            <p className="my-1">{value.employee__email_address}</p>
            <span className={`d-inline-block my-1 ${!!value.employee__job ? 'bg-primary' : 'bg-secondary'} bg-primary text-white p-1 rounded rounded-lg`}>{value.employee__job || t('No Position')}</span>
          </div>
        </div>
      </div>

      <Form onSubmit={onSubmit}>
        <EmployeeForm model="local" readOnly={readOnly} t={t} />
        {!readOnly && (
          <div className="d-flex justify-content-between">
            {/* <CashHoliday
              onSubmit={onCashHolidaySubmit}
              client={payroll}
              url={`${url}/${pay_slip_id}/employee_accrued`}
            /> */}
            <SubmitButton>Save</SubmitButton>
          </div>
        )}
      </Form>
      {
        readOnly && !value.paid &&
        <Card body className="text-left py-2 px-3 my-2">
          <div className="d-inline-block my-2">
            <BillPayment payroll={payroll} t={t} url={`pay_runs/${id}/pay_slips/${pay_slip_id}/pay_payslip`} amount={value?.net_pay - value?.total_paid} setReload={setReload} key={value?.total_paid}></BillPayment>
          </div>
        </Card>
      }

    </Page>
  );
};

export default PaySlip;
